import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
// export default (props) => (
//   <USTemplateDefault
//     lang="en"
//     market="us"
//     video={videos.altitude_sports.videoUrl}
//     title="Watch Altitude Sports with Fubo"
//     subtitle="SEE THE AVALANCHE, NUGGETS & MORE"
//     tagline="Stream it live anytime, anywhere, from any device. Regional restrictions apply."
//     networkSet="sports"
//     customNetworks={['altitude']}
//   />
// )

export default (props) => {
  return <RedirectTemplate location={props.location} destination="/tv/" />
}
